export default "./fonts/survio-B3I43-fonts-icomoon.eot";